import { memo } from "react";
import Demo from "@coworker/apprestructured/src/task-management/demo/pages/ComponentDemoPage/demos/Demo/Demo";
import Name from "@coworker/apprestructured/src/task-management/demo/pages/ComponentDemoPage/demos/Name/Name";
import Highlight from "@coworker/apprestructured/src/task-management/demo/pages/ComponentDemoPage/demos/Highlight/Highlight";
import GroupedViewerFragment from "@coworker/apprestructured/src/task-management/components/TaskViewerSheet/viewer-fragments/GroupedViewerFragment/GroupedViewerFragment";
import type { GroupedViewerFragmentConfigProps } from "@coworker/apprestructured/src/task-management/components/TaskViewerSheet/viewer-fragments/GroupedViewerFragment/GroupedViewerFragment";
import type { ViewerFragmentCommonProps } from "@coworker/apprestructured/src/task-management/components/TaskViewerSheet/viewer-fragments/ViewerFragment";
import { LOADING } from "@coworker/apprestructured/src/task-management/loading";

const configProps: GroupedViewerFragmentConfigProps = {
  fragments: [
    {
      id: "titled-text-with-badges-viewer-fragment",
      props: {
        titleField: "details.problem_type.label",
        textField: "details.description",
        badgesField: "details.problem_tags",
        shouldTranslateTitle: true,
        shouldTranslateBadges: true,
      },
    },
    {
      id: "titled-text-with-badges-viewer-fragment",
      props: {
        titleField: "details.discovery_method.label",
        textField: "details.discovery_method.description",
        shouldTranslateTitle: true,
      },
    },
    {
      id: "titled-text-field-viewer-fragment",
      props: {
        title: "whatOtherActions",
        field: "details.other_actions",
      },
    },
    {
      id: "titled-text-field-viewer-fragment",
      props: {
        title: "affectedQuantityString",
        field: "details.quantity_affected",
        suffix: "piecesString",
      },
    },
  ],
};

const mockTask = {
  id: "12345",
  details: {
    problem_type: { label: "pqdProductMalfunction" },
    description: "The electric parts stopped working after a few uses",
    problem_tags: [
      { label: "pqdPMLLeakageAfterUsage", value: "LEAKAGE_AFTER_USAGE" },
      {
        label: "pqdPMElectricPartsNotWorking",
        value: "ELECTRIC_PARTS_NOT_WORKING",
      },
    ],
    discovery_method: {
      label: "pqAssembleString",
      description: "Noticed it while assembling the product",
    },
    other_actions: "Contacted the supplier",
    quantity_affected: "3",
  },
};

const commonProps: ViewerFragmentCommonProps = {
  blockInput: false,
  task: mockTask,
  onTaskChange: () => {},
  showValidation: false,
  taskType: LOADING,
};

function GroupedViewerFragmentDemo() {
  return (
    <Demo>
      <Name>GroupedViewerFragment</Name>

      <Highlight>
        <div style={{ padding: "16px", background: "var(--white)" }}>
          <GroupedViewerFragment
            configProps={configProps}
            commonProps={commonProps}
          />
        </div>
      </Highlight>
    </Demo>
  );
}

export default memo(GroupedViewerFragmentDemo);
